import { ContentLayout } from "@/components/common/content-layout";
import { HasAccess } from "@/components/common/has-access";
import { useAccessMatrix } from "@/features/internal-user/hooks/use-access";
import { AccessMatrixTable } from "@/features/internal-user/ui/access-matrix";

export default function ManageAccess() {
  const { data, isLoading, error } = useAccessMatrix();

  return (
    <HasAccess
      permission="manage_admins"
      fallback={
        <div className="p-6 text-sm text-muted-foreground">
          You do not have access to staff management.
        </div>
      }
    >
      <ContentLayout
        header={
          <div className="space-y-1">
            <h1 className="text-2xl font-semibold">Manage Access</h1>
            <p className="text-sm text-muted-foreground">
              Pick a role, then choose which areas it can view and edit.
            </p>
          </div>
        }
        data={data}
        isLoading={isLoading}
        // Only the FIRST load blanks the grid. ContentLayout reads isFetching as
        // "show the loader instead of the content", and every cell write
        // invalidates this query — so passing the real value would swap the
        // whole table for a 400px spinner on every toggle, collapsing the page
        // height and bouncing the scroll. That flicker is precisely what the
        // optimistic update in useSetAccessCell exists to avoid; the refreshed
        // rows arrive underneath it a moment later.
        isFetching={isLoading}
        error={error}
        errorMessage="Could not load the access matrix"
      >
        {data && <AccessMatrixTable matrix={data} />}
      </ContentLayout>
    </HasAccess>
  );
}
